import {Formik} from 'formik';

import {FormComponent} from './FormComponent';

import {RecordSchema} from './RecordSchema';

import {FormWithButtons} from '@flexinet/ui-components';

import {PaymentProfile} from '../types';
import {stage} from "../../../config/stage";
import {useModals} from "@mantine/modals";

export const RecordForm = ({
                               record,
                               handleSubmit,
                           }: {
    record: Omit<PaymentProfile, 'id'>,
    handleSubmit: (values: PaymentProfile) => void
}) => {
    const {closeAll} = useModals()

    const onSubmit = (values: PaymentProfile) => {
        handleSubmit(values);
        closeAll()
    };

    const onCancel = () => {
        closeAll()
    };


    let initialValues = {} as PaymentProfile;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={onCancel} debug={false && stage === 'ide'} {...rest}  >
                    <FormComponent handleSubmit={handleSubmit} isSubmitting={isSubmitting} {...rest}/>
                </FormWithButtons>)}
        </Formik>
    );
};
